import { Injectable } from "@angular/core";
import { AdditionalFeatureHelper, AssignedProjectFeatureHelper } from "@app/project/model/project-feature";
import { ProjectDbService } from "@app/project/services/project-db.service";
import { EffectsUtils } from "@app/root-store/effects/effect-creators";
import { rekeyDbResultArray } from "@app/shared/resources/resource-objectifier";
import { Actions } from "@ngrx/effects";
import { map } from "rxjs";
import { ProjectFeatureActions } from "../actions";

@Injectable()
export class ProjectFeatureEffects extends EffectsUtils {
    constructor(actions$: Actions, private projectDbService: ProjectDbService) {
        super(actions$);
    }

    getProjectFeature$ = this.createSwitchEffect({
        dbMethod: ({ projectId }) =>
            this.projectDbService.getProjectFeatures(projectId).pipe(
                map(features => {
                    const helper = new AssignedProjectFeatureHelper();
                    return {
                        payload: features.map(f => helper.fromDbObject(f)),
                    };
                })
            ),
        actionSet: ProjectFeatureActions.loadSet,
    });

    getAllAdditionalFeatures$ = this.createSwitchEffect({
        dbMethod: _ =>
            this.projectDbService.getAllAdditionalFeatures().pipe(
                map(rekeyDbResultArray(new AdditionalFeatureHelper())),
                map(features => ({
                    payload: features,
                }))
            ),
        actionSet: ProjectFeatureActions.loadAllAdditionalFeatures,
    });
}
